import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { SimpleLoader } from "./loaders";

const Redirecting = props => {
  const { accessToken } = props;

  if (accessToken) {
    return <Redirect to="/" />;
  } else {
    return <SimpleLoader />;
  }
};

const mapStateToProps = state => ({
  accessToken: state.headers.accessToken
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(Redirecting)
);



// WEBPACK FOOTER //
// ./src/components/Redirecting.js